import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Box, Dialog, Snackbar, Typography } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { colors, fontSizes } from 'style/styleSettings';
import AddEditNotes from 'screens/coach/MemberProfile/components/Documentation/AddEditNotes';
import { useEffect } from 'react';
import ViewNotes from 'screens/coach/MemberProfile/components/Documentation/ViewNotes';
import { useSelector } from 'react-redux';
import { getAlertNoteDetails, getNote } from 'store/actions/memberProfile';
import { useState } from 'react';
import { Alert } from '@material-ui/lab';
import { ALERT_NOTE } from 'constants/app';

const DocumentationStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: 'rgb(240, 240, 240)',
    // '& .MuiAlert-message': {
    //   fontFamily: 'Work Sans',
    //   fontWeight: 600,
    //   textTransform: 'uppercase',
    // },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    color: 'black',
  },
});

const AlertStyles = (theme) => ({
  root: {
    '& .MuiAlert-message': {
      fontFamily: 'Work Sans !important',
      fontWeight: 600,
      textTransform: 'uppercase',
    },
  },
});

const DialogTitle = withStyles(DocumentationStyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: fontSizes.LARGE,
    backgroundColor: 'rgb(240, 240, 240)',
    '& .MuiTypography-body1': {
      fontFamily: 'Work Sans !important',
    },
    '& .MuiTypography-h5': {
      fontFamily: 'Work Sans !important',
    },
    '& .MuiTypography-h4': {
      fontFamily: 'Work Sans !important',
    },
    '& .MuiTypography-body2': {
      fontFamily: 'Work Sans !important',
    },
    '& .MuiSvgIcon-root': {
      color: '#142A39',
    },
  },
  input: {
    fontFamily: 'Work Sans !important',
  },
}))(MuiDialogContent);

export default function Documentation({
  setopenNotesModal,
  noteId,
  onClose,
  memberId,
  openNotesModal,
  file,
  type = null,
  ...other
}) {
  const styles = AlertStyles();
  const teamId = useSelector((state) => state.user.team.id);
  const coachId = useSelector((state) => state.user.profile.id);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [snackbarData, setSnackbarData] = useState({
    open: false,
    severity: null,
    text: null,
  });
  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  //handler to fetch notes for display on table
  const fetchNoteHandler = async () => {
    getNote(teamId, coachId, noteId)
      .then((res) => {
        if (res) {
          let noteData = res.result;
          if (res.result.type === ALERT_NOTE) {
            getAlertNoteDetails(teamId, coachId, noteId).then((res) => {
              setData({ ...res, ...noteData });
            });
          } else {
            setData(noteData);
          }
        }
      })
      .catch((err) => setError(true));
  };

  useEffect(() => {
    fetchNoteHandler();

    //cleanup memory leaks
    return setData(null);
  }, []);

  const snackBarDataHandler = (d) => {
    setSnackbarData(d);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openNotesModal}
      className={styles.root}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography
          variant="h5"
          style={{
            fontFamily: 'Work Sans',
          }}
        >
          {!noteId ? 'Add Note' : 'View Note'}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarData?.open}
            autoHideDuration={6000}
            onClose={() =>
              setSnackbarData((e) => {
                return { ...e, open: false };
              })
            }
          >
            <Alert
              onClose={() =>
                setSnackbarData((e) => {
                  return { ...e, open: false };
                })
              }
              severity={snackbarData?.severity}
              sx={{
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                style={{
                  fontFamily: 'Work Sans',
                  textTransform: 'uppercase',
                  letterSpacing: '0.50px',
                }}
              >
                {snackbarData?.text}
              </Typography>
            </Alert>
          </Snackbar>
        </Box>
        {!noteId ? (
          <AddEditNotes
            memberId={memberId}
            type={type === null ? 'Addhoc Notes' : type}
            snackBarDataHandler={snackBarDataHandler}
            onClose={onClose}
            file={file}
            {...other}
          />
        ) : (
          <ViewNotes
            memberId={memberId}
            snackBarDataHandler={snackBarDataHandler}
            onClose={onClose}
            loading={data === null}
            data={data}
            error={error}
            refetch={() => {
              setData(null);
              fetchNoteHandler();
            }}
            type={type === null ? 'Addhoc Notes' : type}
            {...other}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
